import { SvgIcon, SvgIconProps, SvgIconTypeMap } from '@material-ui/core'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import React from 'react'

const PanelLayoutIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
    props: SvgIconProps
) => (
    <SvgIcon
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        style={{
            width: '16px',
            height: '16px',
            ...props.style,
        }}
    >
        <path
            d="M1.77778 16C1.28889 16 0.870519 15.8261 0.522667 15.4782C0.174815 15.1304 0.000592593 14.7117 0 14.2222V1.77778C0 1.28889 0.174222 0.870519 0.522667 0.522667C0.871111 0.174815 1.28948 0.000592593 1.77778 0H14.2222C14.7111 0 15.1298 0.174222 15.4782 0.522667C15.8267 0.871111 16.0006 1.28948 16 1.77778V14.2222C16 14.7111 15.8261 15.1298 15.4782 15.4782C15.1304 15.8267 14.7117 16.0006 14.2222 16H1.77778ZM9.77778 14.2222V1.77778H1.77778V14.2222H9.77778Z"
            fill="#185E8E"
        />
    </SvgIcon>
)

export default PanelLayoutIcon
